import axios from '../../../configs/axios';

import { portalNode } from './config';
import scrollPage from '../../../utils/scrollPage';

export const getAppIcons = (id) => axios.get(`/financial_reports/${id}/icons`);

export const createReport = (params) => axios.post('/financial_reports', params);

const mobileBreakpoint = 640;
export const scrollTo = (el, offsetTop = 0) => {
  if (window.innerWidth <= mobileBreakpoint) {
    const marketingHeader = document.querySelector('.header-marketing-js');
    const headerHeight = marketingHeader ? marketingHeader.offsetHeight : 0;
    const yOffset = (el || portalNode).getBoundingClientRect().top + window.pageYOffset + offsetTop;

    scrollPage({ destination: yOffset - headerHeight });
  }
};
